import React from 'react'
import './Projects.css'

const Projects = () => {
  return (
    <section id='projects'>
        <div className='container'>
            <div className='titel'>
                <h2>Projects</h2>
                <h3>Projects</h3>
            </div>
        </div>
        <div className='projects-wrapper'>
            <div className='projects-card'>
                <div className='container'>
                    <div className='projects-info'>
                        <h3>01</h3>
                        <div className='projects-head'>
                            <h2>Digi Marketers</h2>
                            <h3>Digital marketing agency website.</h3>
                        </div>
                    </div>
                    <a href='https://digi-marketers.netlify.app' target='_blank' ><h2>VIEW PROJECT</h2><img src='./assets/arrow.svg' alt='' /></a>
                </div>
                <img className='img-project' src='./assets/project1.jpg' alt='' />
            </div>
            <div className='projects-card'>
                <div className='container'>
                    <div className='projects-info'>
                        <h3>02</h3>
                        <div className='projects-head'>
                            <h2>FitCoach</h2>
                            <h3>online fitness coach website.</h3>
                        </div>
                    </div>
                    <a href='https://fitcoach-demo.netlify.app' target={'_blank'}><h2>VIEW PROJECT</h2><img src='./assets/arrow.svg' alt='' /></a>
                </div>
                <img className='img-project' src='./assets/project2.jpg' alt='' />
            </div>
            <div className='projects-card'>
                <div className='container'>
                    <div className='projects-info'>
                        <h3>03</h3>
                        <div className='projects-head'>
                            <h2>Dziri Food</h2>
                            <h3>traditional food restaurant website.</h3>
                        </div>
                    </div>
                    <a href='https://dzirifood.netlify.app' target='_blank'><h2>VIEW PROJECT</h2><img src='./assets/arrow.svg' alt='' /> </a>
                </div>
                <img className='img-project' src='./assets/project3.png' alt='' />
            </div>
        </div>
    </section>
  )
}

export default Projects